// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__LRmHu","name":"section_name__11b6e","post":"section_post__1vmEB","title":"section_title__2p_RQ","text":"section_text__3uLCT"};